import { HttpMethods, APIContexts } from 'enums';
import { apiRequestHandler, apiHost } from '.';

const apiContext = `${APIContexts.USER}/`;

export const GetGridStateAPI = ({ queryParams, onSuccess, ...rest }) => {
  const api = 'GetGridState';
  const endpoint = `${apiHost}${apiContext}${api}?grid=${queryParams.gridName}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess(res),
    ...rest,
  });
};

export const SaveGridStateAPI = ({ requestBody, onSuccess, ...rest }) => {
  const api = 'SaveGridState';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const GetNotifications = ({ includeDeleted, onSuccess, ...rest }) => {
  const api = 'Notifications';

  // Build query params only if includeDeleted is defined (true or false)
  const queryParams =
    includeDeleted !== undefined ? `?includeDeleted=${includeDeleted}` : '';

  const endpoint = `${apiHost}${apiContext}${api}${queryParams}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const GetAllNotifications = ({ includeDeleted, onSuccess, ...rest }) => {
  const api = 'OrgNotifications';

  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const SetNotificationsStatusToRead = ({ ...rest }) => {
  const api = 'Notifications';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.PUT,
    ...rest,
  });
};

export const DeleteNotifications = ({ ...rest }) => {
  const api = 'Notifications';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.DELETE,
    ...rest,
  });
};

export const GetTermsAPI = ({ onSuccess, ...rest }) => {
  const api = 'terms';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.GET,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};

export const AcceptTermsAPI = ({ requestBody, onSuccess, ...rest }) => {
  const api = 'terms';
  const endpoint = `${apiHost}${apiContext}${api}`;
  apiRequestHandler({
    endpoint,
    method: HttpMethods.POST,
    payload: requestBody,
    onSuccess: (res) => onSuccess && onSuccess(res),
    ...rest,
  });
};
